import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../app/services/auth.service';
import { appSetting }  from "../../../../config/appSettings";
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { configService } from "libs-frontend-micro-base";

const defaultLanguages: Map<string,string> = new Map([ 
  ['en', 'English'],
  ['es', 'Español']
 // ['pt', 'Português']
]);

@Component({
    selector: 'footer',
    styleUrls: ['./footer.style.scss'],
    templateUrl: './footer.template.html',
    standalone: false
})
export class Footer implements OnInit {
  public currentLang: string[];
  public languages: Map<string,string> = defaultLanguages;
  public languagesArr: Array<string[]> = Array.from(defaultLanguages.entries());
  public userData: any = {};
  public adminSelectedView: string;
  public isTeacherViewPossible:boolean;
  private adminOnlyViews = [ new RegExp('/\grade-activity-selection')];

  constructor(
    private authService : AuthService,
    private appHelperService: AppHelperService,
  ) {}
  ngOnInit() {
    this.userData = this.authService.getUserData() || {};
    // Get the value from localstorage the current toggle value for admin is "admin/teacher"
    let adminSelectedView = appSetting.localStorage.adminSelectedView + this.userData.extUserId;
    this.adminSelectedView = localStorage.getItem(adminSelectedView);
    this.isTeacherViewPossible = (['teacher', 'admin', 'superadmin'].indexOf(this.userData.role) > -1);
    let lang = this.getLanguageBasedOnRole();
    this.currentLang = lang == null || lang == undefined ? ['en', 'English'] : [lang, defaultLanguages.get(lang)];
  }

  public changeLanguage(lang: string[]) {
    if(this.currentLang[0] != lang[0]) {
      localStorage.setItem(appSetting.localStorage.lang, lang[0]);
      window.location.reload();
    }
  }

  public navigateToOnboardingApp(footerlink) {
    this.appHelperService.navigateToOnboardingApp([footerlink]);
  }

  public gotoHelpPage() {
    this.appHelperService.navigateToApp('', [], { outsideC1Url: configService.getHelpPagePath(APP_ENV, '', '', localStorage.getItem(appSetting.localStorage.lang)), openInNewTab: true });
  }

  private checkAdminOnlyViews(url: string) {
    for (const view of this.adminOnlyViews) {
      if (view.test(url)) {
        return true;
      }
    }
    return false;
  }

  private getLanguageBasedOnRole(){
    let userData = this.authService.getUserData();
    if(!userData || userData.role == 'superadmin') {
        const loggedInUserRole = localStorage.getItem(appSetting.localStorage.loggedInUserRole);
        userData = {role: loggedInUserRole}
    }
    if (this.adminSelectedView && this.checkAdminOnlyViews(window.location.href)) {
      return localStorage.getItem(appSetting.localStorage.lang);
    }
    if(['teacher', 'admin', 'superadmin'].indexOf(userData.role) > -1 ) {
        return 'en';
    } 
    return localStorage.getItem(appSetting.localStorage.lang);
  }

}